export enum SpinnerSizes {
  S = 's',
  M = 'm',
  L = 'l'
}
